import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import $ from 'jquery';
import './index.scss'
import 'bootstrap/dist/js/bootstrap.min.js';
import { Provider } from 'react-redux';
import { store, persistor } from './Store';
import { PersistGate } from 'redux-persist/integration/react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { LoadScript } from '@react-google-maps/api';
import 'select2/dist/css/select2.min.css';
import 'select2';
import '../src/config/ChartjsSetup';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'Home.scss'


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement); // Add type assertion

(window as any).$ = $;
(window as any).jQuery = $;

serviceWorkerRegistration.register();

root.render(
  <React.StrictMode>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
  </React.StrictMode>
);
